import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M.125 13c0-2.89 3.984-8.984 5.86-11.719.507-.703 1.484-.703 1.992 0C9.852 4.016 13.875 10.11 13.875 13A6.86 6.86 0 0 1 7 19.875 6.836 6.836 0 0 1 .125 13m3.75 0c0-.312-.312-.625-.625-.625a.64.64 0 0 0-.625.625A4.37 4.37 0 0 0 7 17.375a.64.64 0 0 0 .625-.625c0-.312-.312-.625-.625-.625-1.758 0-3.125-1.367-3.125-3.125"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }